export enum URLTargetType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
